"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatUserState(object) {
    return checkExternalChatUserState(object).fulfilled;
}
exports.isExternalChatUserState = isExternalChatUserState;
function checkExternalChatUserState(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("userId"), __1.hasArray("organizationsAdded", __1.isString()), __1.hasArray("unreadChannels", __1.isString())).withOptions(options).explain();
}
exports.checkExternalChatUserState = checkExternalChatUserState;
//# sourceMappingURL=ExternalChatUserState.js.map